import {
  HttpApiError,
  HttpApiMiddleware,
  HttpApiSecurity,
} from "@effect/platform";
import { CurrentUser } from "./context";

export class Authorization extends HttpApiMiddleware.Tag<Authorization>()(
  "Authorization",
  {
    failure: HttpApiError.Unauthorized,
    provides: CurrentUser,
    security: { bearer: HttpApiSecurity.bearer },
  },
) {}
